import { Table, TableBody } from "@mui/material";
import { LocationOn as AddressIcon } from "@mui/icons-material";
import type { VendorProfileFacility } from "../types";
import { SectionCard } from "../components/SectionCard";
import { FieldRow } from "../components/FieldRow";
import { formatText } from "../utils/format";

type Props = { profile: VendorProfileFacility };

export function AddressSection({ profile }: Props) {
  return (
    <SectionCard icon={<AddressIcon fontSize="small" />} title="Address">
      <Table size="small">
        <TableBody>
          <FieldRow label="Address Lines" value={profile.address_billing} />
          <FieldRow label="Pincode" value={profile.location_pincode} />
          <FieldRow label="City" value={formatText(profile.billing_city)} />
          <FieldRow label="Country" value={formatText(profile.billing_country)} />
        </TableBody>
      </Table>
    </SectionCard>
  );
}

export default AddressSection;
